import React, { useEffect, useState } from 'react';
import { Modal, Button, Typography, Select, Flex, Tag } from 'antd';
import { EditOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import styles from './queue-selector.module.scss';
import { useSelector } from 'react-redux';
import { useToggle } from 'hooks/useToggle';

const { Title, Paragraph } = Typography;

export const QueueSelector = ({ loading, userId, status, updateUserStatus, queuePosition = 1, teamInQueue = 12 }) => {
  const { userStatus, queueTag } = useSelector((state) => state.spot);
  const [isQueueModalOpen, toggleQueueModal] = useToggle(false);
  const [isEditingStatus, setEditingStatus] = useState(false);

  const [selection, setSelection] = useState('active|available');
  useEffect(() => {
    if (status) {
      setSelection(status);
    }
  }, [status]);

  const handleJoinQueue = async () => {
    const [uStatus, tag] = selection.split('|');
    await updateUserStatus(userId, `${uStatus}|${tag}`);

    toggleQueueModal();
  };

  const statuses = [
    {
      value: 'active|available',
      label: (
        <>
          <Tag className={`${styles.tagStatuses} font-600`} style={{ color: '#166534' }} color="#b6e4c7">
            Available
          </Tag>{' '}
          (Receives leads)
        </>
      ),
    },
    {
      value: 'deactive|lunch',
      label: (
        <>
          <Tag className={`${styles.tagStatuses} font-600`} style={{ color: '#9a3411' }} color="#ffedd5">
            Lunch
          </Tag>{' '}
          (Does not receives leads)
        </>
      ),
    },
    {
      value: 'deactive|meeting',
      label: (
        <>
          <Tag className={`${styles.tagStatuses} font-600`} style={{ color: '#1f42af' }} color="#dbeafe">
            Meeting
          </Tag>{' '}
          (Does not receives leads)
        </>
      ),
    },
    {
      value: 'active|training',
      label: (
        <>
          <Tag className={`${styles.tagStatuses} font-600`} style={{ color: '#7837b1' }} color="#f3e8ff">
            Training
          </Tag>{' '}
          (Receives leads)
        </>
      ),
    },
    {
      value: 'deactive|away',
      label: (
        <>
          <Tag className={`${styles.tagStatuses} font-600`} style={{ color: '#1e2a37' }} color="#f3f4f6">
            Away
          </Tag>{' '}
          (Does not receives leads)
        </>
      ),
    },
  ];

  return (
    <>
      <Button
        size="large"
        onClick={toggleQueueModal}
        className={!userStatus ? styles.deactive : styles[userStatus]}
        icon={userStatus === 'active' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
        loading={loading}
        data-component-path="crm-spot/layouts/crm-spot-layout/queue-button">
        <span style={{ textTransform: 'capitalize' }}>
          {!userStatus ? 'Join Lead Queue' : `${userStatus} (${queueTag})`}
        </span>
      </Button>
      <Modal
        title={<Title level={4}>Lead Queue Settings</Title>}
        open={isQueueModalOpen}
        onCancel={toggleQueueModal}
        footer={() => (
          <>
            <Flex gap="small">
              <Button size="large" block onClick={toggleQueueModal}>
                Cancel
              </Button>
              <Button
                size="large"
                block
                type="primary"
                loading={loading}
                style={{ textTransform: 'capitalize' }}
                onClick={handleJoinQueue}>
                Join as "{selection.split('|')[1]}"
              </Button>
            </Flex>
          </>
        )}>
        <div>
          <div className={styles.content}>
            <div className={styles.header}>
              <Paragraph type="secondary">
                {userStatus === 'deactive'
                  ? `You're active with status "${queueTag}" and ${teamInQueue ? 'receiving' : 'not receiving'} leads.`
                  : 'Select your status and join the queue to manage lead assignments.'}
              </Paragraph>
            </div>

            {(!userStatus || isEditingStatus) && (
              <div className={styles.statusSelector}>
                <Paragraph>Select your status</Paragraph>

                <Select
                  defaultValue="available"
                  value={selection}
                  onChange={(value) => {
                    setSelection(value);
                    setEditingStatus(false);
                  }}
                  size="large"
                  disabled={loading}
                  placeholder="Select Status"
                  options={statuses}
                  className={styles.select}
                />
              </div>
            )}

            {userStatus && !isEditingStatus && (
              <Flex
                justify="space-between"
                align="center"
                className={`${styles.currentStatus} bg-gray-50 border-lightgray`}>
                <Flex vertical justify="center">
                  <Paragraph className="font-600 font-14 spacing-mb-0">Current Status</Paragraph>
                  <Paragraph className="font-700 font-16 text-capitalize spacing-mb-0" strong>
                    {queueTag}
                  </Paragraph>
                </Flex>
                <Button
                  type="link"
                  onClick={() => setEditingStatus(true)}
                  className={styles.editButton}
                  disabled={userStatus === 'paused'}
                  icon={<EditOutlined />}>
                  Change
                </Button>
              </Flex>
            )}

            {/* {!userStatus && (
              <Flex vertical gap="small">
                <Flex gap="small" align="center">
                  <Text strong>Queue Status:</Text>
                  <Tag>{queueTag}</Tag>
                </Flex>
                <Flex gap="small" align="center">
                  <Text strong>Queue Position:</Text>
                  <Text>{queuePosition}</Text>
                </Flex>
                <Flex gap="small" align="center">
                  <Text strong>Team in Queue:</Text>
                  <Text>{teamInQueue}</Text>
                </Flex>
              </Flex>
            )} */}
          </div>
        </div>
      </Modal>
    </>
  );
};
